import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject, Subject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {ColdStore} from '../../pages/user-management/cold-store/cold-store.model';

export interface ColdStoreRequestParam {
    id: number;
    name: string;
    profileId: number[];
    userId: number[];
    createdOn: string;
    statusId: number;
    status: string;
    coordinates: string;
    location: string[];
    online: boolean;
    profileName: string;
    partyId: number[];
    profileTypeId: number[];
    commodityId: number[];
    profileTypeName: string;
    commodityName: string;
    siteId: number[];
    siteName: string[];
    regionId: number[];
    regionName: string[];
    esclationLevelId: string[];

}

@Injectable()
export class ColdStoreService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

  getGraphDetailByDate(pageNumber: any, limit: any, id: any, startDate:any, endDate:any)
    {

      let params: HttpParams = new HttpParams();
      params = params.append('p', pageNumber);
      params = params.append('l', limit);
        params = params.append('startDate', startDate);
          params = params.append('endDate', endDate);
      return this.apiRequest.get(this.appConfig.graph_detail_url + '/' + id + '/data/date/filters', params);


  }

  // fetch All Cold Store
    getAllColdStore(pageNumber: any, limit: any): Observable<any> {
        const me = this;
        const coldStoreListSubject = new Subject<any>(); // Will use this subject to emit data that we want
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
       /* params = params.append('s', '0');*/
        me.apiRequest.get(this.appConfig.cold_store_url, params).subscribe(jsonResp => {
            const items = jsonResp.data.map(function (v) {
                return Object.assign({}, v, {
                    id: `${v.id}`,
                    name: `${v.name}`,
                    profileId: `${v.profileId}`,
                    userId: `${v.userId}`,
                    statusId: `${v.statusId}`,
                    status: `${v.status}`,
                    coordinates: `${v.coordinates}`,
                    location: `${v.location}`
                });
            });

            const coldObj = Object.assign({}, jsonResp, {
                data: items
            });
            coldStoreListSubject.next(coldObj); // incidentList is a Subject and emits an event thats being listened to by the components
        });
        return coldStoreListSubject;
    }
    getColdStoreDetailsById(pageNumber: any, limit: any, id: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        return this.apiRequest.get(this.appConfig.cold_store_url + '/' + id + '/data/', params);
    }

    getColdStoreById(id: any): Observable<any> {
        return this.apiRequest.get(this.appConfig.cold_store_url + '/' + id + '/graph-details/');
    }

    getColdStoreBasedOnFilter(coldStore: ColdStore, pageNumber: any, limit: any): Observable<any> {
        const me = this;
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', limit);
        const bodyData =  {
            'partyId': coldStore.partyId,
            'userId': coldStore.userId,
            'profileId': coldStore.profileId,
            'regionId': coldStore.regionId,
            'siteId': coldStore.siteId,
            'profileTypeId': coldStore.profileTypeId,
            'commodityTypeId': coldStore.commodityId,
            'connectivity': coldStore.online,
            'esclationLevelId': coldStore.esclationLevelId,
            'csStatusId': coldStore.csStatusId
            /*'connectivity': coldStore.connectivity,*/

        };
      //  console.log('check' + coldStore.profileName);
        const pickDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt
        return me.apiRequest.post(this.appConfig.cold_store_url + '/filters?p=0&l=30000', bodyData);

        // return pickDataSubject;
    }

    getLocationDD(): Observable<any> {
        return this.apiRequest.get(this.appConfig.cold_store_url + '/dd/locations');
    }


}
